import SkeletonText from 'components/loaders/SkeletonText';
import CaptionText from 'components/text/CaptionText';

import useTranslation from './hooks/useTranslation';

import { SKELETON_LINES, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const ServiceIntervalsModalPlaceholder: FunctionComponent<Props> = ({
    isLoading = false,
    testId = TEST_ID
}) => {
    const { NO_ASSETS } = useTranslation();

    if (isLoading) {
        return <SkeletonText lines={SKELETON_LINES} testId={testId} />;
    }

    return <CaptionText testId={testId} text={NO_ASSETS} />;
};

export default ServiceIntervalsModalPlaceholder;
